var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-6 mx-auto" },
      [
        _c("newsroom-item-editor-wrapper", {
          attrs: { title: _vm.resource("Newsroom_Create_Header") },
          scopedSlots: _vm._u([
            {
              key: "action-buttons",
              fn: function(ref) {
                var isValid = ref.isValid
                var newsroomItem = ref.newsroomItem
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary navbar-btn",
                      class: { disabled: !isValid },
                      on: {
                        click: function($event) {
                          return _vm.submit(isValid, newsroomItem)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.resource("Newsroom_Create_Submit_Btn")))]
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }